import combinedGACall from '../combinedGACall';

export default (action, label) =>
	combinedGACall({
		category: 'Resources',
		action,
		label,
	});
